<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h3 class="heading">Current Address Proof</h3>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11 white_box p-4">
                <form [formGroup]="model" (ngSubmit)="submit()" novalidate autocomplete="off">
                    <div class="row justify-content-center">
                        <div class="col-11 p-4">
                            <!-- 
                        <div class="residance-wrapper mb-4">
                                <label class="control-label">Residence Type</label>
                                <div class="d-flex align-items-center justify-content-between gap-2 w-100">
                                    <div class="card shadow" *ngFor="let type of residenceTypes"
                                        [ngClass]="{ active: type === selectedResidence }"
                                        (click)="onResidenceSelect(type)">
                                        <div class="card-body text-center">
                                            <p class="residence_type mb-2">{{ type }}</p>
                                            <img [src]="
                          type.includes('Rented')
                            ? '../../assets/images/rent.png'
                            : '../../assets/images/landlord.png'
                        " alt="residence_icon" class="img-fluid" />
                                        </div>
                                    </div>
                                </div>
                            </div> -->


                            <div class="form-group">

                                <label class="control-label pb-2" style="text-align: left; width: 100%;">Select
                                    Residence Type</label>

                                <div class="d-flex align-items-stretch gap-2 w-100 profession-cards">
                                    <div class="card shadow" *ngFor="let type of residenceTypes"
                                        [ngClass]="{ active: type === selectedResidence }"
                                        (click)="onResidenceSelect(type)">

                                        <div class="card-body d-flex flex-column">
                                            <div class="row h-100 flex-grow-1">
                                                <div
                                                    class="col-md-6 col-12 d-flex justify-content-center align-items-center">
                                                    <p class="profession_type">{{ type }}</p>
                                                </div>
                                                <div class="col-md-6 col-12 profession_icon text-center">
                                                    <img [src]="
                          type.includes('Rented')
                            ? '../../assets/images/rent.png'
                            : '../../assets/images/landlord.png'
                        " alt="residence_icon" class="img-fluid">
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div *ngIf="m.residenceType.touched && m.residenceType.invalid" class="error">
                                    Please select employee type
                                </div>
                            </div>

                            <!-- Document Type -->
                            @if(m.residenceType.valid){
                            <div class="form-group mt-3">
                                <label class="control-label">Document Type</label>
                                <select formControlName="documentType" class="form-select">
                                    <option value="Select document type" disabled selected>Select Document Type</option>
                                    <option
                                        *ngFor="let type of model.get('residenceType')?.value === 'I Own My Home' ? documentOwnedTypes : documentRentedTypes"
                                        [value]="type">
                                        {{ type }}
                                    </option>
                                </select>
                            </div>

                            <!-- File Upload -->
                            <div class="form-group mt-4" *ngIf="model.get('documentType')?.value">
                                <label class="control-label">
                                    Upload {{ model.get('documentType')?.value }} <span class="text-danger">*</span>
                                </label>
                                <input type="file" accept=".pdf,.jpg,.jpeg,.png" class="form-control mt-2"
                                    (change)="onFileSelected($event)" />
                            </div>

                            <!-- Submit -->
                            <div class="text-center mt-4">
                                <button type="submit" class="btn btn-warning"
                                    [disabled]="!model.valid || !fileSelected">
                                    Submit & Verify My Address
                                </button>
                            </div>
                            }
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-11">
        <app-left-icons></app-left-icons>
    </div>
</div>
<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>